import ProductCard from './ProductCard';
import './styles.scss';

const ProductCards = ({ data }) => (
    <section className="container">
        <div className="inner-container type-2">
            <div className="product-card-container">
                {data?.map((item, index) => (
                    <ProductCard
                        key={index}
                        index={index}
                        title={item?.preview_title}
                        text={item?.preview_text}
                        img={item?.preview_image}
                        logo={item?.preview_logo}
                        buttonText={item?.preview_link_text}
                    />
                ))}
            </div>
        </div>
    </section>
);

export default ProductCards;
